<template>
  <div class="mt-3">
    <div class="row">
      <div class="col">
        <ul class="">
          <li v-html="$t('ct-checkout-gateway-stripe-info-line1')"></li>
          <li>{{ $t('ct-checkout-gateway-stripe-acess-page-here') }} <a class="underline" target="_blank"
                                                                        href="https://dashboard.stripe.com/login">
            https://dashboard.stripe.com/login</a></li>
          <li v-html="$t('ct-checkout-gateway-stripe-info-line3')"></li>
          <li v-html="$t('ct-checkout-gateway-stripe-info-line4')"></li>
          <li v-html="$t('ct-checkout-gateway-stripe-info-line5')"></li>
          <li v-html="$t('ct-checkout-gateway-stripe-info-line6')"></li>
        </ul>
      </div>
      <div class="col">
        <!-- Input Description -->
        <div class="form-group">
          <label for="name" class="control-label">{{ $t('ct-name') }}</label>
          <div class="" :class="{'has-error': e.has('name')}">
            <input type="text" class="form-control" @input="e.remove('name')" id="name" name="name"
                   v-model="config.name">
            <span class="label label-danger" v-if="e.has('name')">{{ e.first('name') }}</span>
          </div>
        </div>

        <!-- Input Client_id -->
        <div class="form-group">
          <label for="client_id" class="control-label">{{ $t('ct-cliente-id') }}</label>
          <div class="" :class="{'has-error': e.has('client_id')}">
            <input type="text" class="form-control" id="client_id" name="client_id" @input="e.remove('client_id')"
                   v-model="config.client_id">
            <span class="label label-danger" v-if="e.has('client_id')">{{ e.first('client_id') }}</span>
          </div>
        </div>

        <!-- Input Secret -->
        <div class="form-group">
          <label for="secret" class="control-label">{{ $t('ct-secret') }}</label>
          <div class="" :class="{'has-error': e.has('secret')}">
            <input type="text" class="form-control" id="secret" name="secret" @input="e.remove('secret')"
                   v-model="config.secret">
            <span class="label label-danger" v-if="e.has('secret')">{{ e.first('secret') }}</span>
          </div>
        </div>

        <!-- Input One_click_payments -->
        <div class="form-group">
          <label for="one_click_payments" class="control-label">{{
              $t('ct-checkout-gateway-stripe-one-click-payments')
            }}</label>
          <div class="">
            <input id="one_click_payments" v-model="config.one_click_payments" class="" type="checkbox" value="1">
          </div>
        </div>

      </div>
    </div>
    <span class="label label-danger" v-if="e.has('keys')">{{ e.first('keys') }}</span>
    <div>
      <!-- Form Submit -->
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <button class="btn btn-default" @click="$emit('cancel')">{{ $t('ct-cancel') }}</button>
          <button type="button" class="btn btn-info" @click="save">{{ $t('ct-save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StripeConfig',
  props: ['value', 'e'],

  data() {
    return {
      config: this.value || {}
    };
  },

  watch: {
    config: {
      handler(config) {
        this.$emit('input', config);
      },
      deep: true
    },
    'value': function(val) {
      this.$emit('input', this.config);
    }
  },

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        name: 'required',
        client_id: 'required',
        secret: 'required'
      });

      this.e.validate(this.config);

      if (!this.e.any()) this.$emit('save', this.config);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/GatewayConfig/StripeConfig.vue